// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"8d94c036","599":"2fccd5fc","787":"043d8d24","807":"7776cef3","845":"edbe25f6","910":"f479f9e4","925":"abd1763a"}[chunkId] + ".chunk.js";
};